import { columns } from 'app/config/grid';

/**
 * Given a number of columns, it will return the percentage
 * of width for that column (a number between 0 and 1).
 *
 * @param subset
 */
export const getWidthByColumns = subset => (1 / columns) * subset;
